const Logo = () => {
	return (
		<div className="px-4 py-3">
			<h1 className="flex h-8 w-8 items-center justify-center rounded bg-neutral-900 text-white">
				A
			</h1>
		</div>
	);
};

export { Logo };
